import Raven from 'raven-js';

Raven.config('//dummy/identity/js_errors').install();
Raven._globalEndpoint = '/identity/js_errors';

export default Raven;
